/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= module component import section ========= //
import {
  Modal,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import Datetime from 'react-datetime';
// ====== end of module component import section ====== //

// ========= project component import section ========= //
// ====== end of project component import section ====== //

// ========= action import section ========= //
import {
  doGetBankAccounts,
  doPostBankTransferConfirm,
} from '../../actions/paymentAction';
import { doFetchUserBankAccount } from '../../actions/postalCodeAction';
import moment from 'moment';
import DataPaymentInterface, {
  BankAccountsInterface,
} from '../../interface/reducers/payment';
import AnalyticsWrapper from '../../services/Analytics';
import { toast } from 'react-toastify';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
// ====== end of action import section ====== //

// ========= interface import section ========= //
// ====== end of interface import section ====== //

interface SubmitPayloadInterface {
  invoice_number: string;
  transfer_amount: string;
  name: string;
  transfer_date: string;
  bank_account_id: number;
}

interface PaymentInfoInterface {
  invoiceNumber: string;
  transferAmount: number;
}

type stateToProps = {
  dataPayment?: DataPaymentInterface;
};

interface ModalPaymentConfirmation extends stateToProps {
  isOpen: boolean;
  onToggle: () => any;
  getBankAccountList: () => Promise<any>;
  getUserBankAccount: () => Promise<any>;
  submit: (payload: SubmitPayloadInterface) => Promise<any>;
  paymentInfo?: PaymentInfoInterface;
  callback: () => void;
}

const DATE_FORMAT = 'MMMM DD, YYYY';
const DATE_FORMAT_SUBMIT = 'YYYY-MM-DD';

/**
 * Modal for Bank Transfer Payment Confirmation for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalPaymentConfirmation} props for this component.
 * @return {JSX.Element}
 */
function ModalPaymentConfirmationComponent({
  isOpen,
  onToggle,
  paymentInfo,
  getBankAccountList,
  getUserBankAccount,
  submit,
  callback,
}: ModalPaymentConfirmation): JSX.Element {
  const [invoiceNumber, setInvoiceNumber] = useState('');
  const [nominal, setNominal] = useState(0);
  const [behalfName, setBehalfName] = useState('');
  const [transactionDate, setTransactionDate] = useState<any>(
    moment().format(DATE_FORMAT),
  );
  const [targetAccount, setTargetAccount] = useState(0);

  const [bankAccountList, setBankAccountList] = useState<
    BankAccountsInterface[]
  >([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const selectedBank = bankAccountList.find((t) => t.id === targetAccount);
  const displayBankName = selectedBank
    ? `${selectedBank.account_number} - ${selectedBank.bank_name} - ${selectedBank.account_name}`
    : '-';

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  useEffect(() => {
    defaultState()
  }, []);

  const defaultState = () => {
    getUserBankAccount().then((res) => {
      setBehalfName(res.value?.data[0]?.account_name);
    });
    getBankAccountList().then((r) => {
      setBankAccountList(r.value.data);
      setTargetAccount(r.value.data[0]?.id);
    });
  }

  useEffect(() => {
    if (!isOpen) {
      setInvoiceNumber('')
      setNominal(0)
      setBehalfName('')
      setTransactionDate(moment().format(DATE_FORMAT))
      setTargetAccount(0)
    } else {
      defaultState()
    }
  }, [isOpen])

  useEffect(() => {
    if (paymentInfo && paymentInfo.invoiceNumber) {
      setInvoiceNumber(paymentInfo.invoiceNumber);
    }
    if (paymentInfo && paymentInfo.transferAmount) {
      setNominal(paymentInfo.transferAmount);
    }
  }, [paymentInfo]);

  const onChangeTxtInput = (e: any) => {
    switch (e.target.name) {
      case 'transferAmount':
        const dataBidAmount = parseInt(
          e.target.value
            ? `${e.target.value.replace(/[\. ,:-]+/g, '')}.00`
            : '0.00',
        );
        setNominal(dataBidAmount);
        break;
      case 'invoiceNumber':
        setInvoiceNumber(e.target.value);
        break;
      case 'behalfName':
        setBehalfName(e.target.value);
        break;
      default:
        return null;
    }
  };

  const onChangeDatePicker = (value: any) => {
    const date =
      value !== null && value['_isAMomentObject']
        ? value.format(DATE_FORMAT)
        : value;
    setTransactionDate(date);
  };

  const onConfirm = () => {
    const body = {
      bank_account_id: 1,
      invoice_number: invoiceNumber,
      name: behalfName,
      transfer_amount: nominal.toString(),
      transfer_date: moment(transactionDate).format(DATE_FORMAT_SUBMIT),
    };
    AnalyticsWrapper.recordPaymentCompletion(body);
    submit(body)
      .then(() => callback())
      .catch((err) => {
        callback();
        toast.error(
          err.response?.data?.error?.message
            ? err.response.data.error.message
            : 'Sorry, we have a problem!. Please inform our friendly staff via Whatsapp +6281210005425',
          {
            position: 'top-right',
            autoClose: 7000,
            closeOnClick: true,
            pauseOnHover: true,
          },
        );
      });
  };

  return (
    <Modal
      className="payment-confirmation-modal"
      toggle={onToggle}
      isOpen={isOpen}
      centered
    >
      <>
        <p className={'title'}>Payment Confirmation</p>
        <p className={'description'}>
          Mohon untuk melakukan konfirmasi (khusus untuk metode pembayaran bank
          transfer) setelah berhasil melakukan pemesanan produk dari website
          guna mempercepat proses pembelian. Isi form dibawah ini sesuai dengan
          detail yang diminta.
        </p>

        <div className={'form-container'}>
          <p>Order ID*</p>
          <input
            type={'text'}
            placeholder={'No. Invoice, contoh: KA-XXXXXX-XXX-XXXXXXX'}
            name={'invoiceNumber'}
            onChange={onChangeTxtInput}
            value={invoiceNumber}
          />
        </div>

        <div className={'form-container'}>
          <p>Jumlah yang dibayarkan*</p>
          <div className={'currency-form'}>
            {nominal !== 0 ? (
              <div className={'currency-prefix'}>
                <p>IDR</p>
              </div>
            ) : (
              <div className={'currency-prefix-invisible'} />
            )}
            <CurrencyFormat
              placeholder={'Jumlah nominal yang dibayar'}
              decimalSeparator={','}
              thousandSeparator={'.'}
              onChange={onChangeTxtInput}
              value={nominal == 0 ? '' : nominal}
              name={'transferAmount'}
            />
          </div>
        </div>

        <div className={'form-container'}>
          <p>Nama pemilik rekening*</p>
          <input
            type={'text'}
            placeholder={'Nama pemilik rekening'}
            name={'behalfName'}
            onChange={onChangeTxtInput}
            value={behalfName}
          />
        </div>

        <div className={'form-container'}>
          <p>Tanggal transaksi*</p>
          {/* <input type={'text'} placeholder={'Tanggal transaksi'} /> */}
          <Datetime
            value={transactionDate}
            onChange={onChangeDatePicker}
            timeFormat={false}
            inputProps={{
              placeholder: 'Tanggal transaksi',
              className: 'pointer',
            }}
          />
        </div>

        <div className={'form-container'}>
          <p>Dibayarkan ke rekening*</p>
          {/* <input type={'text'} placeholder={'Pilih rekening Kick Avenue'} /> */}
          <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle
              tag={'div'}
              className={'dropdown-container'}
              data-toggle={'dropdown'}
              aria-expanded={dropdownOpen}
            >
              {displayBankName}
            </DropdownToggle>
            <DropdownMenu>
              {bankAccountList.map((t) => {
                const onClick = () => {
                  toggleDropdown();
                  setTargetAccount(t.id);
                };
                return (
                  <DropdownItem key={t.id} onClick={onClick}>
                    {`${t.account_number} - ${t.bank_name} - ${t.account_name}`}
                  </DropdownItem>
                );
              })}
            </DropdownMenu>
          </Dropdown>
        </div>

        <div className={'button-confirm'} onClick={onConfirm}>
          <p>Confirm</p>
        </div>
      </>
      <div className={'close-button'} onClick={onToggle}>
        <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
          <div>
            <GrClose />
          </div>
        </IconContext.Provider>
      </div>
    </Modal>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {};
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {
    getBankAccountList: () => dispatch(doGetBankAccounts()),
    getUserBankAccount: () => dispatch(doFetchUserBankAccount()),
    submit: (payload: SubmitPayloadInterface) =>
      dispatch(doPostBankTransferConfirm(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalPaymentConfirmationComponent);
